import React, { useRef, useEffect, useState, useCallback } from 'react';
import CommonIn from '../utils/CommonIn';
import CompomentUtil from '../utils/ComponentUtil';
import emailjs from '@emailjs/browser';

const Contract = () => {
    const titleRef = useRef('');
    const nameRef = useRef('');
    const companyRef = useRef('');
    const phoneRef = useRef('');
    const emailRef = useRef('');
    const timeRef = useRef('');
    const messageRef = useRef('');
    const privacyAgreeRef = useRef(null);

    const [showPrivacyPolicyPopup, setShowPrivacyPolicyPopup] = useState(false);
    const [showPrivacyDocPopup, setShowPrivacyDocPopup] = useState(false);
    const [privacyHtml, setPrivacyHtml] = useState('');
    const [privacyLoading, setPrivacyLoading] = useState(false);
    const [privacyFailed, setPrivacyFailed] = useState(false);
    const privacyAbortRef = useRef(null);

    const loadPrivacyPolicy = useCallback(async () => {
        if (privacyAbortRef.current) {
            privacyAbortRef.current.abort();
        }
        const controller = new AbortController();
        privacyAbortRef.current = controller;

        setPrivacyLoading(true);
        setPrivacyFailed(false);
        setPrivacyHtml('');

        try {
            const response = await fetch('/policies/privacy-v1.0.htm', { cache: 'no-store', signal: controller.signal });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const html = await response.text();
            if (html.toLowerCase().includes('<div id="root"></div>')) throw new Error('SPA fallback');
            setPrivacyHtml(html);
        } catch (error) {
            if (error.name !== 'AbortError') setPrivacyFailed(true);
        } finally {
            if (!controller.signal.aborted) setPrivacyLoading(false);
        }
    }, []);

    //  추가: sendButton을 참조할 ref 
    const sendButtonRef = useRef(null);

    // CommonIn 및 ComponentUtil 초기화 (기존 useEffect 유지)
    useEffect(() => {
        CommonIn();
        CompomentUtil();
    }, []);

    // 🌟🌟🌟 send Request 로직을 별도의 useEffect로 분리 및 useRef 사용 🌟🌟🌟
    useEffect(() => {
        const sendButton = sendButtonRef.current; // useRef를 통해 DOM 요소 접근
        if (sendButton) { // DOM 요소가 존재하는지 확인
            const sendClickHandler = () => {
                const title = titleRef.current ? titleRef.current.value : '';
                const name = nameRef.current ? nameRef.current.value : '';
                const company = companyRef.current ? companyRef.current.value : '';
                const phone = phoneRef.current ? phoneRef.current.value : '';
                const email = emailRef.current ? emailRef.current.value : '';
                const time = timeRef.current ? timeRef.current.value : '';
                const message = messageRef.current ? messageRef.current.value : '';
            
                if (!title || !name || !company || !phone || !/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(email) || !message) {
                    alert('모든 필수 필드를 채워주세요 (이메일 형식 확인).');
                    return;
                }
                if (!/^\d{2,3}-\d{3,4}-\d{4}$/.test(phone)) {
                    alert('올바른 전화번호 형식을 입력해주세요 (예: 010-1234-5678)');
                    return;
                }
                if (!privacyAgreeRef.current || !privacyAgreeRef.current.checked) {
                    alert('개인정보 수집 및 이용 동의는 필수입니다.');
                    return;
                }

                var templateParams = {
                    'title': title,
                    'name': name,
                    'company': company,
                    'phone': phone,
                    'email': email,
                    'time': time,
                    'message': message             
                };
                
                emailjs.send('service_psk8wnn', 'template_zag7v85', templateParams, {
                    publicKey: 'RX4msQsv_7k30Cgxv',
                })
                .then(
                    () => {
                        console.log('SUCCESS!');
                        alert('문의가 성공적으로 접수되었습니다. 감사합니다!');
                        // 메일 전송 성공 알림 추가
                        alert('메일이 정상적으로 전송되었습니다. 빠른 시일 내에 답변드리겠습니다.');
                    },
                    (error) => {
                        console.log('FAILED...', error.text);
                        alert('문의 접수에 실패했습니다. 다시 시도해 주세요.');
                    },
                );
            };
            sendButton.addEventListener('click', sendClickHandler);

            // 🌟🌟🌟 클린업 함수: 컴포넌트 언마운트 시 이벤트 리스너 제거 🌟🌟🌟
            return () => {
                sendButton.removeEventListener('click', sendClickHandler);
            };
        }
    }, []); // sendButton의 로직은 다른 상태에 의존하지 않으므로 빈 의존성 배열 유지

    // 🌟🌟🌟 파일 업로드 관련 스크립트는 모두 주석 처리 🌟🌟🌟
    useEffect(() => {
        /*
        // 파일 업로드 관련 DOM 요소 참조 (이제 사용되지 않음)
        // const fileInput = document.getElementById('fileInput');
        // const uploadButton = document.getElementById('uploadButton');
        // const fileInfo = document.getElementById('fileInfo');
        // const dropArea = document.getElementById('dropArea');

        // let selectedFiles = [];

        // Update the displayed file list
        // function updateFileDisplay() {
        //     fileInfo.innerHTML = ''; // Clear current file display
        //     selectedFiles.forEach((file, index) => {
        //         const fileItem = document.createElement('div');
        //         fileItem.className = 'file-item';

        //         const fileName = document.createElement('span');
        //         fileName.textContent = file.name;

        //         const deleteIcon = document.createElement('div');
        //         deleteIcon.className = 'delete-icon';
        //         deleteIcon.textContent = '×';
        //         deleteIcon.addEventListener('click', () => {
        //             selectedFiles.splice(index, 1); // Remove file from the list
        //             updateFileDisplay(); // Refresh file display
        //             updateDropAreaText();
        //         });

        //         fileItem.appendChild(fileName);
        //         fileItem.appendChild(deleteIcon);
        //         fileInfo.appendChild(fileItem);
        //     });
        // }

        // Update the drop area text
        // function updateDropAreaText() {
        //     if (selectedFiles.length < 3) {
        //         dropArea.textContent = '파일을 이곳에 드래그 하거나 버튼을 눌러 업로드 하세요 (최대 3개)';
        //     } else {
        //         dropArea.textContent = '더 이상 파일을 추가할 수 없습니다 (최대 3개)';
        //     }
        // }

        // Add files to the selected list
        // function addFiles(files) {
        //     if (selectedFiles.length + files.length > 3) {
        //         alert('최대 3개의 파일만 업로드할 수 있습니다.');
        //     } else {
        //         selectedFiles = selectedFiles.concat(files).slice(0, 3); // Limit to 3 files
        //         updateFileDisplay();
        //         updateDropAreaText();
        //     }
        // }

        // Handle file selection via input
        // if (fileInput) {
        //     const fileInputChangeHandler = (event) => {
        //         const files = Array.from(event.target.files);
        //         addFiles(files);
        //         fileInput.value = ''; // Reset file input to allow re-selection
        //     };
        //     fileInput.addEventListener('change', fileInputChangeHandler);
        // }

        // Handle file upload
        // if (uploadButton) {
        //     const uploadButtonClickHandler = () => {
        //         if (selectedFiles.length === 0) {
        //             alert('업로드할 파일을 선택하세요.');
        //             return;
        //         }

        //         const formData = new FormData();
        //         selectedFiles.forEach((file, index) => {
        //             formData.append(`file${index + 1}`, file);
        //         });

        //         fetch('your-server-endpoint', {
        //             method: 'POST',
        //             body: formData,
        //         })
        //         .then(response => response.json())
        //         .then(data => {
        //             alert('File(s) uploaded successfully!');
        //             console.log(data);
        //             selectedFiles = []; // 파일 업로드 후 초기화
        //             updateFileDisplay();
        //             updateDropAreaText();
        //         })
        //         .catch(error => {
        //             alert('Failed to upload file(s).');
        //             console.error(error);
        //         });
        //     };
        //     uploadButton.addEventListener('click', uploadButtonClickHandler);
        // }

        // Handle drag-and-drop
        // if (dropArea) {
        //     const dragOverHandler = (event) => {
        //         event.preventDefault(); // Allow drop
        //         dropArea.classList.add('drag-over');
        //     };
        //     const dragLeaveHandler = () => {
        //         dropArea.classList.remove('drag-over');
        //     };
        //     const dropHandler = (event) => {
        //         event.preventDefault(); // Prevent default behavior (file open)
        //         dropArea.classList.remove('drag-over');

        //         const files = Array.from(event.dataTransfer.files);
        //         addFiles(files);
        //     };
        //     dropArea.addEventListener('dragover', dragOverHandler);
        //     dropArea.addEventListener('dragleave', dragLeaveHandler);
        //     dropArea.addEventListener('drop', dropHandler);

        //     const dropAreaClickHandler = () => {
        //         fileInput.click();
        //     };
        //     dropArea.addEventListener('click', dropAreaClickHandler);
        // }
        */

        // Prevent default drag-and-drop behavior for the entire window
        // 이 부분도 주석 처리하여 전역 D&D 방지 기능 비활성화
        // const windowDragOverHandler = (event) => event.preventDefault();
        // const windowDropHandler = (event) => event.preventDefault();
        // window.addEventListener('dragover', windowDragOverHandler);
        // window.addEventListener('drop', windowDropHandler);

        // return () => {
        //     window.removeEventListener('dragover', windowDragOverHandler);
        //     window.removeEventListener('drop', windowDropHandler);
        // };
    }, []); // 파일 업로드 기능이 없으므로 의존성 배열은 비워두거나, 이 useEffect를 제거할 수 있습니다.

    return (
        <>
            <main className="submain" id="submain">
                <div className="sub_header_non"></div>
                <section className="visual_sec solution_vs">
                    <div className="container visual_inner">
                        <div className="visual_text">
                            <h2>무료체험 신청하기</h2>
                            <p>인공지능과 혁신으로 더 안전하고 간편하게!<br/>지금 무료로 체험해보세요.</p>
                        </div>
                    </div>
                </section>
                <section className="contact_box">
                    <div className="container">
                        <div className="contact_input_wrap">
                            <div className="contact_form">
                                <div className="listbox_wrap mg_bt_10">
                                    <label htmlFor="input_03"><h4>회사명</h4></label>
                                    <input id="input_account" type="text" ref={companyRef} placeholder="회사명을 입력해 주세요" aria-describedby="error_msg_account" aria-invalid="true"/>
                                </div>
                                <div className="listbox_wrap mg_bt_10">
                                    <label htmlFor="input_03"><h4>성함</h4></label>
                                    <input id="input_account" type="text" ref={nameRef} placeholder="성함을 입력해 주세요" aria-describedby="error_msg_account" aria-invalid="true"/>
                                </div>
                            </div>
                            <div className="contact_form">
                                <div className="listbox_wrap mg_bt_10">
                                    <label htmlFor="input_03"><h4>연락처</h4></label>
                                    <input id="input_account" type="text" ref={phoneRef} placeholder="연락처를 입력해 주세요" aria-describedby="error_msg_account" aria-invalid="true"/>
                                </div>
                                <div className="listbox_wrap mg_bt_10">
                                    <label htmlFor="input_03"><h4>이메일</h4></label>
                                    <input id="input_account" type="text" ref={emailRef} placeholder="답변받으실 이메일 주소를 입력해 주세요" aria-describedby="error_msg_account" aria-invalid="true"/>
                                </div>
                            </div>
                            <div className="contact_form02">
                                <div className="listbox_wrap mg_bt_10">
                                    <label htmlFor="input_02"><h4>제목</h4></label>
                                    <input id="input_account" type="text" ref={titleRef} placeholder="제목을 입력해 주세요" aria-describedby="error_msg_account" aria-invalid="true"/>
                                </div>
                            </div>
                            <div className="contact_form02">
                                <div className="listbox_wrap mg_bt_10">
                                    <label htmlFor="input_03"><h4>문의내용</h4></label>
                                    <textarea id="input_account" ref={messageRef} placeholder="사업장 주소, 직원 수, 문의하실 내용을 작성해 주세요"></textarea>
                                </div>
                            </div>

                            {/* 🌟🌟🌟 첨부파일 섹션 (JSX)도 완전히 주석 처리 🌟🌟🌟 */}
                            {/*
                            <div style={{ textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
                                <button
                                    type="button"
                                    onClick={() => setShowAttachment(!showAttachment)}
                                    className="btn_toggle_attachment"
                                >
                                    {showAttachment ? '첨부파일 숨기기' : '첨부파일 추가하기'}
                                </button>
                            </div>

                            {showAttachment && (
                                <div className="contact_form02">
                                    <div className="listbox_wrap mg_bt_10">
                                        <div className="upload_tit">
                                            <h4>첨부파일</h4>
                                            <div className="upload_guide">* PPT,PDF,DOC 50MB 업로드 가능합니다.</div>
                                        </div>
                                        <div className="rf_con">
                                            <div className="issue_chk_box upload_box">
                                                <div className="issue-list">
                                                    <div id="dropArea" className="custom-file-upload" ref={dropAreaRef}>
                                                        <img src="../../assets/images/upload_ic.svg" alt="upload"/>
                                                        파일을 이곳에 드래그 하거나 버튼을 눌러 업로드 하세요 (최대 3개)
                                                    </div>
                                                    <input type="file" id="fileInput" multiple style={{display: "none"}} ref={fileInputRef}/>
                                                    <button id="uploadButton" ref={uploadButtonRef}>업로드</button>
                                                    <div id="fileInfo" ref={fileInfoRef}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            */}

                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '14px' }}>
                            <input
                                id="privacy-agree"
                                type="checkbox"
                                ref={privacyAgreeRef}
                                style={{ width: '1em', height: '1em', flexShrink: 0, cursor: 'pointer' }}
                            />
                            <label htmlFor="privacy-agree" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                (필수) 개인정보 수집 및 이용에 동의합니다.
                            </label>
                            <button
                                type="button"
                                onClick={() => setShowPrivacyPolicyPopup(true)}
                                style={{
                                    border: 'none',
                                    background: 'none',
                                    color: '#0b5ed7',
                                    textDecoration: 'underline',
                                    padding: 0,
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                    fontSize: 'inherit'
                                }}
                            >
                                전문보기
                            </button>
                        </div>
                        <div className="contact_btn_wrap">
                            <button id="sendButton" className="btn_submit" ref={sendButtonRef}>신청하기</button>
                        </div>
                    </div>  
                </section>
            </main>

            {showPrivacyPolicyPopup && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-label="개인정보 수집 및 이용 안내"
                    onClick={() => setShowPrivacyPolicyPopup(false)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.55)',
                        zIndex: 10000,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '20px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: '100%',
                            maxWidth: '640px',
                            maxHeight: '80vh',
                            overflowY: 'auto',
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            padding: '28px',
                            boxSizing: 'border-box',
                            lineHeight: 1.8,
                            fontSize: '15px',
                            color: '#333'
                        }}
                    >
                        <h3 style={{ marginTop: 0, marginBottom: '24px', fontSize: '18px', fontWeight: '600', color: '#111827' }}>개인정보 수집 및 이용에 대한 안내</h3>

                        <p style={{ margin: '0 0 20px 0', fontSize: '14px', color: '#555', lineHeight: 1.8 }}>
                            드림티원은 개인정보 보호법 제15조제1항제1호에 따라, 다음과 같은 개인정보를 수집·이용합니다.
                        </p>

                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ margin: '0 0 8px 0', fontSize: '15px', fontWeight: '600', color: '#222' }}>1. 개인정보 수집 및 이용목적</p>
                            <p style={{ margin: '0 0 0 16px', fontSize: '14px', color: '#555' }}>무료체험신청 온라인 문의 접수 및 처리</p>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ margin: '0 0 8px 0', fontSize: '15px', fontWeight: '600', color: '#222' }}>2. 수집하는 개인정보의 항목</p>
                            <p style={{ margin: '0 0 0 16px', fontSize: '14px', color: '#555' }}>[필수] 성명, 연락처, 이메일 주소, 회사명</p>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ margin: '0 0 8px 0', fontSize: '15px', fontWeight: '600', color: '#222' }}>3. 개인정보의 보유 및 이용 기간</p>
                            <p style={{ margin: '0 0 0 16px', fontSize: '14px', color: '#555' }}>목적 달성 후 1개월 이내 삭제</p>
                        </div>

                        <div style={{ marginBottom: '24px', paddingTop: '16px', borderTop: '1px solid #e5e7eb' }}>
                            <p style={{ margin: '16px 0 8px 0', fontSize: '15px', fontWeight: '600', color: '#222' }}>4. 자세한 사항</p>
                            <p style={{ margin: '0 0 0 16px', fontSize: '14px', color: '#555' }}>
                                <button
                                    type="button"
                                    onClick={() => { loadPrivacyPolicy(); setShowPrivacyDocPopup(true); }}
                                    style={{ border: 'none', background: 'none', color: '#0b5ed7', textDecoration: 'underline', padding: 0, cursor: 'pointer', fontSize: 'inherit', fontWeight: '600' }}
                                >
                                    개인정보처리방침
                                </button>
                                을 참고해주시기 바랍니다.
                            </p>
                        </div>

                        <div style={{ paddingTop: '16px', borderTop: '1px solid #e5e7eb', marginTop: '24px' }}>
                            <p style={{ margin: '16px 0 0 0', fontSize: '13px', color: '#666', lineHeight: 1.7 }}>
                                위 동의를 거부할 권리가 있으며, 필수항목의 동의를 거부하실 경우 문의 처리 및 결과 회신이 제한됩니다.
                            </p>
                        </div>

                        <div style={{ textAlign: 'right', marginTop: '24px' }}>
                            <button
                                type="button"
                                onClick={() => setShowPrivacyPolicyPopup(false)}
                                style={{
                                    backgroundColor: '#1f2937',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '10px 18px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showPrivacyDocPopup && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-label="개인정보처리방침 전문"
                    onClick={() => { if (privacyAbortRef.current) privacyAbortRef.current.abort(); setShowPrivacyDocPopup(false); }}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.65)',
                        zIndex: 10001,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '18px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: '100%',
                            maxWidth: '980px',
                            height: '82vh',
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', borderBottom: '1px solid #e5e7eb' }}>
                            <strong style={{ fontSize: '17px', color: '#111827' }}>개인정보처리방침</strong>
                            <button
                                type="button"
                                onClick={() => { if (privacyAbortRef.current) privacyAbortRef.current.abort(); setShowPrivacyDocPopup(false); }}
                                style={{ border: 'none', background: '#111827', color: '#fff', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer', fontSize: '14px' }}
                            >
                                닫기
                            </button>
                        </div>

                        {privacyLoading && (
                            <div style={{ padding: '24px', color: '#374151', fontSize: '14px' }}>
                                정책 문서를 불러오는 중입니다...
                            </div>
                        )}

                        {!privacyLoading && !privacyFailed && privacyHtml && (
                            <iframe
                                srcDoc={privacyHtml}
                                title="개인정보처리방침 전문"
                                style={{ width: '100%', flex: 1, border: 'none', backgroundColor: '#fff' }}
                            />
                        )}

                        {!privacyLoading && privacyFailed && (
                            <div style={{ padding: '24px', color: '#374151', fontSize: '14px' }}>
                                개인정보처리방침 문서를 불러오지 못했습니다.
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Contract;